export const formatMoney = (amount: number, showCurrencySign: boolean = true): string => {
  if (amount === null || amount === undefined) return ''
  return `${showCurrencySign ? '$' : ''}${
    Number.isInteger(amount)
      ? amount
      : amount
          .toLocaleString(undefined, {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          })
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }`
}

export const formatMoneyIntegers = (amount: number, showCurrencySign: boolean = true): string => {
  if (amount === null || amount === undefined) return ''
  return `${showCurrencySign ? '$' : ''}${amount
    .toLocaleString(undefined, {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    })
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
}
